import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Puzzle } from "lucide-react";
import { mediaUrl } from "../../lib/api";

function ServiceCard({ item, index }) {
  return (
    <motion.a
      href="#contacto"
      data-testid={`service-card-${index}`}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: (index % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
      className="group relative overflow-hidden border border-peca-line bg-peca-surface min-h-[280px] flex flex-col justify-between p-6 hover:border-peca-yellow transition-colors duration-300"
    >
      <div
        className="absolute inset-0 opacity-20 group-hover:opacity-40 group-hover:scale-105 transition-all duration-500 grayscale"
        style={{ backgroundImage: `url(${mediaUrl(item.image)})`, backgroundSize: "cover", backgroundPosition: "center" }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-peca-surface via-peca-surface/80 to-transparent" />
      <div className="relative flex items-start justify-between">
        <span className="font-mono-p text-peca-yellow text-sm">{item.tag}</span>
        <ArrowUpRight
          size={22}
          className="text-peca-grey group-hover:text-peca-yellow group-hover:rotate-45 transition-all duration-300"
        />
      </div>
      <div className="relative">
        <h3 className="font-display font-bold uppercase text-2xl md:text-3xl tracking-tight text-peca-cream mb-3">
          {item.title}
        </h3>
        <p className="text-peca-grey text-sm leading-relaxed max-w-sm">{item.description}</p>
      </div>
    </motion.a>
  );
}

export default function Services({ content }) {
  const s = content?.services || {};
  const items = s.items || [];
  const connect = s.connectCard || {};

  return (
    <section id="servicos" data-testid="services-section" className="py-24 md:py-40">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16">
          <div>
            <span className="label-mono text-peca-yellow">✳ {s.eyebrow}</span>
            <h2 className="mt-5 font-display font-extrabold uppercase text-4xl md:text-6xl tracking-tight leading-[0.95] text-peca-cream max-w-2xl">
              {s.title}
            </h2>
          </div>
          <p className="text-peca-grey max-w-sm text-base leading-relaxed">{s.intro}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {items.map((item, i) => (
            <ServiceCard key={i} item={item} index={i} />
          ))}

          {/* Connect CTA card — distinct yellow */}
          <motion.a
            href="#contacto"
            data-testid="service-connect-card"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            className="group relative overflow-hidden bg-peca-yellow text-peca-black min-h-[280px] flex flex-col justify-between p-6 hover:bg-peca-cream transition-colors duration-300"
          >
            <div className="flex items-start justify-between">
              <Puzzle size={30} className="group-hover:rotate-12 transition-transform duration-300" />
              <ArrowUpRight size={26} className="group-hover:rotate-45 transition-transform duration-300" />
            </div>
            <div>
              <h3 className="font-display font-extrabold uppercase text-2xl md:text-3xl tracking-tight mb-3">
                {connect.title}
              </h3>
              <p className="text-sm leading-relaxed max-w-sm mb-4 opacity-90">{connect.description}</p>
              <span className="font-display font-bold uppercase text-sm tracking-wide underline decoration-2 underline-offset-4">
                {connect.cta} ↗
              </span>
            </div>
          </motion.a>
        </div>
      </div>
    </section>
  );
}
